module.exports = __webpack_public_path__ + "static/media/pirate.e34665e1.png";